module.exports = __webpack_public_path__ + "img/content1.932f91a5.png";